// extracted by mini-css-extract-plugin
module.exports =  {"c-seo-text-title":"_025a50318d--c-seo-text-title--K5eWL","c-seo-text-col":"_025a50318d--c-seo-text-col--Afwga"};